import { render } from "./particulesV2.vue?vue&type=template&id=167e3b82&scoped=true"
import script from "./particulesV2.vue?vue&type=script&lang=js"
export * from "./particulesV2.vue?vue&type=script&lang=js"

import "./particulesV2.vue?vue&type=style&index=0&id=167e3b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167e3b82"]])

export default __exports__